/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIModel,
    AIModelFromJSON,
    AIModelFromJSONTyped,
    AIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIDatasetDetailReference
 */
export interface AIDatasetDetailReference {
    /**
     * 
     * @type {string}
     * @memberof AIDatasetDetailReference
     */
    id: string;
    /**
     * 
     * @type {AIModel}
     * @memberof AIDatasetDetailReference
     */
    trainingModel?: AIModel;
    /**
     * 
     * @type {AIModel}
     * @memberof AIDatasetDetailReference
     */
    lastFinishedModel?: AIModel;
    /**
     * 
     * @type {Date}
     * @memberof AIDatasetDetailReference
     */
    readonly lastChange?: Date;
    /**
     * 
     * @type {string}
     * @memberof AIDatasetDetailReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof AIDatasetDetailReference
     */
    readonly type?: AIDatasetDetailReferenceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AIDatasetDetailReference
     */
    readonly connection?: number;
}

/**
* @export
* @enum {string}
*/
export enum AIDatasetDetailReferenceTypeEnum {
    Normal = 'normal',
    FaceLibrary = 'face-library',
    Stt = 'stt'
}

export function AIDatasetDetailReferenceFromJSON(json: any): AIDatasetDetailReference {
    return AIDatasetDetailReferenceFromJSONTyped(json, false);
}

export function AIDatasetDetailReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIDatasetDetailReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trainingModel': !exists(json, 'training_model') ? undefined : AIModelFromJSON(json['training_model']),
        'lastFinishedModel': !exists(json, 'last_finished_model') ? undefined : AIModelFromJSON(json['last_finished_model']),
        'lastChange': !exists(json, 'last_change') ? undefined : (new Date(json['last_change'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'connection': !exists(json, 'connection') ? undefined : json['connection'],
    };
}

export function AIDatasetDetailReferenceToJSON(value?: AIDatasetDetailReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'training_model': AIModelToJSON(value.trainingModel),
        'last_finished_model': AIModelToJSON(value.lastFinishedModel),
    };
}


